import React from 'react'
import { useNavigate } from 'react-router-dom'

function NewMessageTitle({ title }) {
  const navigate = useNavigate()

  return (
    <div className="flex justify-between mt-14">
      <h1 className="text-xl my-auto font-bold dark:text-amber-50">{title} پیامک</h1>
      <button
        onClick={() => navigate(-1)}
        className="h-11 px-5 py-2.5 text-md font-medium flex items-center justify-center transition-all duration-300 ease-linear whitespace-nowrap"
      >
        <span className={'text-blue pl-2 font-bold dark:text-amber-50'}>بازگشت</span>
        <i className={`icon-arrow-left-mini text-blue`} />
      </button>
    </div>
  )
}

export default React.memo(NewMessageTitle)
